module.exports = __webpack_public_path__ + "static/hero_visual_title_a-bc64d596b6c3214325b1df0d0344b7ba.png";